import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "helper/global";

const initialState = null;

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.HOME_LOAD:
      return updateObject(state, action);
    case actionTypes.HOME_CLEAR:
      return null;
    default:
      return state;
  }
};

export default reducer;
